import { dataBookmark } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBookmark = /*#__PURE__*/createIcon(dataBookmark)
export default IconBookmark
